// src/components/icons/GroupIcon.js
import React from 'react';

export const GroupIcon = React.memo(({ 
  size = 30, 
  color = "currentColor",
  className,
  "aria-label": ariaLabel,
  ...props 
}) => {
  const groupClipId1 = React.useId();
  const groupClipId2 = React.useId();
  
  return (
  <svg 
    width={size}
    height={size}
    viewBox="0 0 240 240" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role={ariaLabel ? "img" : undefined}
    aria-label={ariaLabel}
    aria-hidden={!ariaLabel}
    focusable="false"
    {...props}
  >
    {/* Speech Bubble Container */}
    <path 
      d="M120 20C64.8 20 20 60.4 20 110c0 26.4 11.6 50.2 30 66.7V220l43.3-23.8c8.6 2.4 17.5 3.8 26.7 3.8 55.2 0 100-40.4 100-90s-44.8-90-100-90z" 
      fill="none" 
      stroke={color} 
      strokeWidth="16" 
      strokeLinejoin="round"
    />
    
    {/* App Icon */}
    <g transform="translate(120, 103)">
      <g transform="scale(0.22) translate(-959.5, -988.25)">
        <defs>
          <clipPath id={groupClipId1}>
            <path transform="matrix(1,0,0,-1,0,2100)" d="M682.955 817.892H1236.08V1405.64H682.955Z"/>
          </clipPath>
          <clipPath id={groupClipId2}>
            <path d="M682.955 694.361H1236.08V1282.11H682.955Z"/>
          </clipPath>
        </defs>
        
        <g clipPath={`url(#${groupClipId1})`}>
          <g clipPath={`url(#${groupClipId2})`}>
            <path 
              transform="matrix(1,0,0,1,719.3793,1270.9481)"
              d="M0 0C-25.5733-10.1636-32.2031-38.953-32.7827-63.8311-36.1741-103.8335-32.3199-144.1753-23.9729-183.3639 2.4302-300.2039 57.0737-419.4825 154.3526-493.4964 269.0361-576.3367 379.5731-516.6754 435.72-399.9089 475.7094-325.2054 491.767-241.0483 501.705-157.6865 505.4504-127.3269 508.4385-96.8759 512.3652-66.5463 516.4522-40.3228 495.8724-13.9802 469.5732-11.1317 405.0906-7.7822 413.6924-72.9762 406.7316-117.5377 396.7729-209.1299 382.9814-304.0092 331.5067-382.6584 284.0091-458.9828 229.676-438.9352 176.8651-380.9936 110.2505-301.056 68.5398-197.423 64.9014-93.1869 82.393-72.4674 75.7886-48.4608 65.6308-26.2537 55.623-1.2402 24.5587 10.9099 0 0Z"
              fill={color}
            />
            <path 
              transform="matrix(1,0,0,1,922.1392,1261.0895)"
              d="M0 0C-35.7896-20.0966-37.5303-108.7694-35.3162-146.041-67.7695-151.6171-99.6852-160.4106-130.3821-172.3004-148.0616-179.9852-167.2889-186.4347-181.8959-199.3832-206.4777-222.9163-197.2935-267.7908-165.4991-279.8619-145.2554-289.3126-124.9126-279.3882-106.9949-269.6957-80.5886-258.5684-53.0182-249.9596-24.837-244.6641-13.4348-298.2914 6.9025-352.6768 47.1346-391.4127 93.2284-438.4121 165.9474-443.3353 209.904-390.9031 251.4787-339.1295 242.7736-260.4473 205.0638-208.9536 172.4855-164.7767 116.7159-143.6155 63.4035-139.88 62.7615-121.772 61.975-103.5461 65.3414-85.667 70.3845-63.2681 81.9431-38.6858 67.8721-17.1965 54.6887 5.8879 22.6016 14.0411 0 0ZM76.0794-241.2992C97.543-246.0477 120.6439-255.5623 130.8643-276.381 137.1099-290.0828 145.0364-319.9997 130.136-329.7169 97.8559-313.2368 85.6287-273.9106 76.0794-241.2992Z"
              fill={color}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
  );
});

GroupIcon.displayName = 'GroupIcon';